<div class="flex h-100 flex-column">
  <div class="map-form container">
    <mat-form-field class="w-100" appearance="fill">
      <mat-label>Location</mat-label>
      <input
        matInput
        type="text"
        id="addresstext"
        #addresstext
        [(ngModel)]="userAddress"
      />
      @if (!userAddress()) {
        <!-- <mat-icon matSuffix>search</mat-icon> -->
        <button matSuffix matIconButton aria-label="Clear" (click)="delete()">
          <mat-icon>search</mat-icon>
        </button>
      }
      @if (userAddress()) {
        <button matSuffix matIconButton aria-label="Clear" (click)="delete()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <button
      type="button"
      class="primary-button"
      [disabled]="!mapAddress()"
      (click)="save()"
    >
      Confirm Location
    </button>
  </div>
  <div class="map-container flex-1">
    <div id="snackbar"></div>
    @if (userAddress()) {
      <div class="centerMarker" [class]="urlParams()?.routeType"></div>
    }
    @if (!userAddress()) {
      <div class="message">Move the map to refine your location</div>
    }
    <google-map
      height="100%"
      width="100%"
      [zoom]="zoom"
      [center]="center()"
      [options]="options"
      (mapDragend)="dragEnd()"
    ></google-map>
  </div>
</div>
